import React, { useState } from 'react';
import { Box, Button, Typography, Stack, Dialog, DialogContent, List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import ParticleLayer from '../components/ui/ParticleLayer';
import Avatar from "../assest/avaratr.png"
import Innovasense from "../assest/innovasense.png"
import DubaiHealthLogo from "../assest/DubaiHealthLogo.png"

const EMIRATES_IDS = [
  { id: '784198800000001', name: 'Ahmed Al Mansoori' },
  { id: '784198800000002', name: 'Fatima Al Suwaidi' },
  { id: '784198800000003', name: 'Omar Al Nuaimi' },
  { id: '784198800000004', name: 'Layla Al Hashimi' },
  { id: '784198800000005', name: 'Hassan Al Shamsi' },
  { id: '784198800000006', name: 'James Carter' },
  { id: '784198800000007', name: 'Sophie Müller' },
  { id: '784198800000008', name: 'Luca Rossi' },
  { id: '784198800000009', name: 'Emma Johansson' },
  { id: '784198800000010', name: 'Pierre Dubois' }
];

export default function Login({ onLogin }) {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setDialogOpen(true);
  };

  const handleEmiratesIdSelect = (person) => {
    setDialogOpen(false);
    onLogin?.({ emiratesId: person.id, name: person.name });
  };

  return (
    <Box sx={{ 
      minHeight: '120vh', 
      width: "100%",
      display: 'flex',
      flexDirection: { xs: 'column', md: 'row' },
      gap: { xs: 2, md: 3 }, 
      alignItems: "center",
      justifyContent: 'center',
      px: { xs: 2, sm: 3, md: 0 },
      position: 'relative',
      isolation: 'isolate',
      overflow: 'hidden',
    }}>
            <ParticleLayer />
           <Box sx={{display:"flex",flexDirection:{xs:"column",md:"row"}, zIndex: 1, width: '100%'}}>
              <Box sx={{
        width: { xs: "100%", sm: "90%", md: "60vw" },
        mt: { xs: "-50px", md: "120px"},
        px: { xs: 2, sm: 3, md: 0 },
           pl: { xs: 1.5, md: "100px" },
        textAlign: { xs: 'left', md: 'left' }
      }}>
          <Typography
          sx={{
            fontFamily: "Dubai",
            fontSize: { xs: "26pt",  md: "36pt" },fontWeight:"500",
            lineHeight: {xs:"28pt",md:"36pt"}
          }}
        >
          AI-Powered <br/>Self Symptom Assessment
        </Typography>
          <Typography
          sx={{
             fontFamily: "Dubai",
            fontSize: { xs: "13pt", md: "17pt" },
            textAlign:{xs:"left"},
            mt: { xs: 2, md: 2 },
            lineHeight: {xs:"20pt",md:"24pt"},
            color:"#BBC6D3",
            width:{xs:"90%",md:"80%"}
            // width:"80%"
          }}
          >
          A clinical-grade, AI-powered platform for self-symptom assessment, featuring human-like AI avatars that guide you in real time. Your reliable first step toward understanding your health.
            </Typography>
            
            {/* Dubai Health Logo - Upper Right Corner */}
            {/* <img 
              src={DubaiHealthLogo} 
              alt="Dubai Health Authority" 
              style={{
                position: "absolute", 
            top: 0, 
            left: 100, 
            width: "120px",
            maxWidth: "180px", 
                height: "auto"
              }}
            /> */}


              <Box
  component="img"
  src={DubaiHealthLogo}
  alt="AI Doctor Avatar"
  sx={{
     position: "absolute", 
    width: {
      xs: "130px",   // mobile
      md: "180px"    // desktop
    },
     left: {xs:20,md:100},
   top:0
  }}
/>
            
            {/* Innovasense Logo - Top right Corner */}
            <img 
              src={Innovasense} 
              alt="Innovasense" 
              style={{
                position: "absolute", 
            top: 30, 
            right: 30, 
            width: "200px",
            maxWidth: "350px", 
                height: "auto",
                opacity: 1
              }}
            />
        </Box>
      <Box sx={{
        width: { xs: "100%", sm: "90%", md: "40vw" },
          pr: { xs: 0, md: "100px" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center", 
        mt: { xs: 2, md: -26 }
      }}>
     <Box
  component="img"
  src={Avatar}
  alt="AI Doctor Avatar"
  sx={{
    width: {
      xs: "270px",   // mobile
      md: "400px"    // desktop
    },
    height: "auto",
    maxWidth: "100%",
  }}
/>

       
        {/* <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>Log in to consult the AI Doctor</Typography> */}
        <Stack 
          component="form" 
          spacing={2} 
          onSubmit={handleSubmit} 
          sx={{
            p: { xs: 2, sm: 3, md: 4 },   
            width: "100%",
            maxWidth: { xs: "350px", md: "500px" },    
        background: "rgba(6, 24, 66, 0.84)",
            backdropFilter: "blur(20px)",
            borderRadius: "10px"
          }}
        >
          <Button 
            type="submit" 
            variant="contained" 
            size="large" 
            sx={{
              position: "relative",
              overflow: "hidden",
              background: "linear-gradient(120deg, #06285f 0%, #0a3f87 30%, #0f5aa7 55%, #0a3f87 78%, #06285f 100%)",
              backgroundSize: "220% 220%",
              animation: "uaePassGradientShift 7s ease-in-out infinite, uaePassGlowPulse 2.8s ease-in-out infinite",
              color: "white",
              py: { xs: 1.5, sm: 2 },
              fontSize: { xs: '12pt', sm: '14pt' },
              borderRadius:"40px",
              fontWeight:"bold",
              lineHeight:"18pt",
              textTransform:"none", fontFamily:"Dubai !important",
              boxShadow: "0 0 14px rgba(24, 122, 255, 0.32)",
              transition: "transform 220ms ease, box-shadow 220ms ease",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: "-35%",
                width: "35%",
                height: "100%",
                background: "linear-gradient(90deg, rgba(75,140,220,0), rgba(75,140,220,0.22), rgba(75,140,220,0))",
                transform: "skewX(-22deg)",
                animation: "uaePassShimmer 3.8s linear infinite",
                pointerEvents: "none",
              },
              "&:hover": {
                transform: "translateY(-1px)",
                boxShadow: "0 0 20px rgba(24, 122, 255, 0.48)",
              },
              "@keyframes uaePassGradientShift": {
                "0%": { backgroundPosition: "0% 50%" },
                "50%": { backgroundPosition: "100% 50%" },
                "100%": { backgroundPosition: "0% 50%" },
              },
              "@keyframes uaePassGlowPulse": {
                "0%": { boxShadow: "0 0 10px rgba(24, 122, 255, 0.25)" },
                "50%": { boxShadow: "0 0 18px rgba(24, 122, 255, 0.48)" },
                "100%": { boxShadow: "0 0 10px rgba(24, 122, 255, 0.25)" },
              },
              "@keyframes uaePassShimmer": {
                "0%": { left: "-35%" },
                "100%": { left: "130%" },
              },
            }}
          >
            Login with UAE PASS
          </Button>
        </Stack>

        {/* Emirates ID Selection Dialog */}
        <Dialog 
          open={dialogOpen} 
          onClose={() => setDialogOpen(false)}
          maxWidth="sm"
          disableRestoreFocus
          PaperProps={{
            sx: {
              background: "#0a2a58",
              backdropFilter: "blur(20px)",
              border: "none",
              borderRadius: "12px",
              width: { xs: "60vw", sm: "400px" },
            }
          }}
        >
          <DialogContent sx={{ pt: 2 }}>
            <List>
              {EMIRATES_IDS.map((person) => (
                <ListItem key={person.id} disablePadding sx={{ mb: 1 }}>
                  <ListItemButton
                    onClick={() => handleEmiratesIdSelect(person)}
                    sx={{
                      py: 0,
                      borderRadius: "8px",
                      border: "1px solid #b2c2d170",
                      transition: "all 0.3s ease",
                      "&:hover": {
                        // #1A4775, #002f70
                        background: "linear-gradient(90deg, #235f9d, #002f70)",
                        borderColor: "#b2c2d1",
                        transform: "translateX(5px)"
                      }
                    }}
                  >
                    <ListItemText
                      primary={person.name}
                      secondary={person.id}
                      primaryTypographyProps={{
                        sx: {
                          fontSize: "13pt",
                           fontFamily: "Dubai",
                          fontWeight: "bold",
                          color: "#ffffff",
                          mb: 0.2,
                          lineHeight:"18pt"
                        }
                      }}
                      secondaryTypographyProps={{
                        sx: {
                          fontFamily: "Dubai",
                          fontSize: "12pt",
                           fontWeight: "400",
                          color: "#99adc2",
                          lineHeight: "18pt",
                        }
                      }}
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </DialogContent>
        </Dialog>
        </Box>
   
    </Box>
    </Box>
  );
}
